import { getRequest } from './index';

export const getAllBlog = async () => getRequest('/blog');

// TODO
/**
 * creo que es aqui donde van los postRequest, putRequest y etc... con su respectivo endpoint
 *
 */